import type { LegislativeTypePublicGetAllResponse } from '@govinity/validation/public';

import { ReadOnlyApi } from '../base';

export class LegislativeTypesApi extends ReadOnlyApi<
  LegislativeTypePublicGetAllResponse,
  object,
  object
> {
  parentPath: string;
  governmentCode: string;

  constructor(governmentCode: string, parentPath: string) {
    super();

    this.parentPath = parentPath;
    this.governmentCode = governmentCode;
  }

  getPath() {
    return `${this.parentPath}/${this.governmentCode}/legislative-types`;
  }

  async getTopUsed() {
    const { data } = await this.request<Array<{ id: number; name: string }>>({
      method: 'GET',
      url: `${this.getPath()}/top-used`,
    });

    return data;
  }
}
